export default __webpack_public_path__ + "98d03b3de0082ae0b14109c72c3a327b.png";